export default {
  CONNECTED: 'connect',
  DISCONNECT: 'disconnect',
  CONNECT_ERROR: 'connect_error',
  AUTHENTICATE: 'authenticate',
  SUBSCRIBE_TO_STORE_CHECKS: 'subscribeToStoreChecks',
  GET_STORE_CHECK_UPDATES: 'getStoreCheckUpdates',
  SUBSCRIBE_TO_STORE_NOTIFICATIONS: 'subscribeToStoreNotifications',
  GET_STORE_CHECKS: 'getStoreChecks',
  GET_STORE_NOTIFICATIONS: 'getStoreNotifications',
  SYNC_STATUS_CONNECTED: 'socket',
  SYNC_STATUS_DISCONNECTED: 'disconnected',
  MDM_POLICY: 'mdm policy update',
  INFO: 'INFO',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
  WARN: 'WARN',
  WEB_SOCKET_CONNECT: 'Web socket connected',
  WEB_SOCKET_DISCONNECT: 'Web socket disconnected'
};
